import React, { useState } from 'react';
import Input from './components/Input';
import Button from './components/Button';
import { Link } from 'react-router-dom';
import { useToast } from './ToastContext';
import axiosInstance from './services/axiosService';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { showToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);
    try {
      await axiosInstance.post('/api/accounts/password_reset/', { email });
      setSuccess(true);
      showToast('Un email de réinitialisation a été envoyé.', 'success');
    } catch (err) {
      const errorMessage = err.response?.data?.detail || "Impossible d'envoyer l'email. Vérifiez l'adresse.";
      setError(errorMessage);
      showToast(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <form onSubmit={handleSubmit} className="bg-white/80 shadow-lg rounded-xl p-8 w-full max-w-md flex flex-col gap-4 border border-blue-gray-100">
        <h1 className="font-heading text-2xl mb-2 text-center">Mot de passe oublié</h1>
        {success && <div className="text-success text-sm text-center mb-2">Un email de réinitialisation a été envoyé.</div>}
        {error && <div className="text-error text-sm text-center mb-2">{error}</div>}
        <Input label="Email" name="email" type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" />
        <Button type="submit" disabled={loading} className="w-full mt-2">{loading ? 'Envoi...' : 'Envoyer le lien'}</Button>
        <div className="text-center mt-2 text-sm text-blue-gray-500">
          <Link to="/login" className="text-accent hover:underline font-heading font-normal">Retour à la connexion</Link>
        </div>
      </form>
    </div>
  );
} 